import { AtlasCore } from '@crossnokaye/typescript-sdk/core';
import { RequestOptions } from '@crossnokaye/typescript-sdk/lib/sdks';
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  SDKError,
  SDKValidationError,
  UnexpectedClientError,
} from '@crossnokaye/typescript-sdk/models/errors';
import { Result, unwrapAsync } from '@crossnokaye/typescript-sdk/types/fp';

import { atlasCore } from '@/singletons';

type AtlasFuncWithRequest<TRequest, TResponse> = (
  core: AtlasCore,
  request: TRequest,
  options?: RequestOptions
) => Promise<
  Result<
    TResponse,
    | SDKError
    | SDKValidationError
    | UnexpectedClientError
    | InvalidRequestError
    | RequestAbortedError
    | RequestTimeoutError
    | ConnectionError
  >
>;

type AtlasFuncWithoutRequest<TResponse> = (
  core: AtlasCore,
  options?: RequestOptions
) => Promise<
  Result<
    TResponse,
    | SDKError
    | SDKValidationError
    | UnexpectedClientError
    | InvalidRequestError
    | RequestAbortedError
    | RequestTimeoutError
    | ConnectionError
  >
>;

interface AtlasClient<TRequest, TResponse> {
  atlasFunc: AtlasFuncWithRequest<TRequest, TResponse> | AtlasFuncWithoutRequest<TResponse>;
  request?: TRequest;
  options?: RequestOptions;
}

export const atlasClient = async <TRequest, TResponse>({
  atlasFunc,
  request,
  options,
}: AtlasClient<TRequest, TResponse>) => {
  if (request) {
    return unwrapAsync(
      (atlasFunc as AtlasFuncWithRequest<TRequest, TResponse>)(atlasCore, request, options)
    );
  }
  return unwrapAsync((atlasFunc as AtlasFuncWithoutRequest<TResponse>)(atlasCore, options));
};
